<div class="wrapper wrapper-dark p-relative">

  <div class="title-section mb-5">{{"Soluzioni"|translate}}</div>
  <!-- card homepage -->
  <div class="pdg-bottom card-wrapper">
    <div class="card-home">
      <div class="card-img">
        <img src="./assets/img/chi-siamo-1.png" class="history-img img-thumbnail">
      </div>
      <div class="card-text">{{"chi-gallerie"|translate}}</div>
    </div>
    <div class="card-home">
      <div class="card-img">
        <img src="./assets/img/chi-siamo-2.png" class="history-img img-thumbnail">
      </div>
      <div class="card-text">{{"chi-cogen"|translate}}</div>
    </div>
  </div>
  <div class="pdg-bottom card-wrapper">
    <div class="card-home">
      <div class="card-img">
        <img src="./assets/img/chi-siamo-3.png" class="history-img img-thumbnail">
      </div>
      <div class="card-text">{{"chi-celleprova"|translate}}</div>
    </div>
    <div class="card-home">
      <div class="card-img">
        <img src="./assets/img/chi-siamo-4.png" class="history-img img-thumbnail">
      </div>
      <div class="card-text">{{"chi-consumienerg"|translate}}</div>
    </div>
  </div>
</div>